module.exports = __webpack_public_path__ + "img/menu_icon01.ae3e9d37.png";